// 获取彩种销售情况
export const GET_LOTTERY_SALEINFO = 'GET_LOTTERY_SALEINFO';

// 初始化玩法信息
export const INIT_METHODS= 'INIT_METHODS';

// UNMOUT的时候清理当前玩法区
export const CLEAR_WINDOW_METHOD = 'CLEAR_WINDOW_METHOD';

// 设置当前玩法区
export const SET_WINDOW_METHOD = 'SET_WINDOW_METHOD';

// 获取动态玩法信息
export const GET_DYNAMIC_METHOD_INFO = 'GET_DYNAMIC_METHOD_INFO';

// 获取静态玩法信息
export const GET_STATIC_METHOD_INFO = 'GET_STATIC_METHOD_INFO';

// 从缓存获取动态玩法信息
export const GET_DYNAMIC_METHOD_INFO_FROM_CACHE = 'GET_DYNAMIC_METHOD_INFO_FROM_CACHE';

// 设置当前窗口ID
export const SET_WINDOWID = 'SET_WINDOWID';

// 添加投注到订单
export const ADD_BET_TO_ORDER = 'ADD_BET_TO_ORDER';

// 添加六合彩投注到订单
export const ADD_BET_TO_ORDER_FOR_LHC = 'ADD_BET_TO_ORDER_FOR_LHC';

// 从订单中删除投注单
export const REMOVE_BET_FROM_ORDER = 'REMOVE_BET_FROM_ORDER';

// 从订单中删除单挑注单
export const REMOVE_SOLOBET_FROM_ORDER = 'REMOVE_SOLOBET_FROM_ORDER';

// 获取当前彩种销售信息
export const GET_CURRENT_ISSUE = 'GET_CURRENT_ISSUE';

// 获取当前可追号奖期
export const GET_TRACK_ISSUES ='GET_TRACK_ISSUES';

// 设置追号信息
export const SET_TRACK_INFO = 'SET_TRACK_INFO';

// 重置追号信息
export const RESET_TRACK_INFO = 'RESET_TRACK_INFO';

// 投注
export const LOTTERY_BET = 'LOTTERY_BET';

// 根据彩种ID获取历史开奖奖期
export const GET_LOTTERY_HISTORY = 'GET_LOTTERY_HISTORY'

// 设置错误信息
export const SET_LOTTERY_ERRORS = 'SET_LOTTERY_ERRORS'

// 获取上一期开奖
export const GET_LAST_ISSUE = 'GET_LAST_ISSUE';

// 模拟开奖
export const SIMULATED_NUMBER = 'SIMULATED_NUMBER'

// 切换模拟开奖状态
export const TOGGLE_SIMULAT_STATUS = 'TOGGLE_SIMULAT_STATUS';

// 秒秒彩投注
export const MMC_LOTTERY_BET = 'MMC_LOTTERY_BET'

// 变更秒秒彩投注状态
export const CHANGE_MMC_BET_STATUS = 'CHANGE_MMC_BET_STATUS'

// 清空秒秒彩执行情况列表
export const MMC_CLEAR_EXCUTE = 'MMC_CLEAR_EXCUTE';

// 切换秒秒彩中奖后停止状态
export const MMC_TOGGLE_STOPWHENWIN = 'MMC_TOGGLE_STOPWHENWIN';

// 秒秒彩变更连续开奖期数
export const MMC_CHANGE_PLAYTIMES = 'MMC_CHANGE_PLAYTIMES';

// 获取彩种有效号码
export const GET_VALID_NUMBER = 'GET_VALID_NUMBER';

// 生成冷热遗漏号码
export const MAKE_MISSCODE_RULE = 'MAKE_MISSCODE_RULE';

// 设置没有投注权限错误
export const SET_NO_BET_AUTH_ERROR = 'SET_NO_BET_AUTH_ERROR';

// 获取彩种返点详情
export const GET_LOTTERY_REBET_INFO = 'GET_LOTTERY_REBET_INFO'

//更新订单 mode
export const UPDATE_MODE_LOTTERY_ODER = 'UPDATE_MODE_LOTTERY_ODER'

//更新订单 times
export const UPDATE_TIMES_LOTTERY_ODER = 'UPDATE_TIMES_LOTTERY_ODER'

// 当前彩种当前奖期结束后本地处理下一期数据
export const NEXT_CURRENT_ISSUE = 'NEXT_CURRENT_ISSUE'

//更新订单
export const UPDATE_ORDER = 'UPDATE_ORDER'

// 获取不推荐彩种，此接口用于弹出提示框，当用户在非推荐彩种时弹出
export const GET_PREVENT_LOTTERYS = 'GET_PREVENT_LOTTERYS'